import Reveal from "../common/reveal";
import { POSITION } from "../../data/home";

const Position = () => (
	<Reveal as="section" className="wrap sec">
		<div className="split">
			<div style={{ flex: "0 1 260px" }}>
				<div className="secnum">01 · Position</div>
			</div>
			<div style={{ flex: "1 1 520px", minWidth: 0 }}>
				<p className="pull">{POSITION.pull}</p>
				{POSITION.paragraphs.map((paragraph, index) => (
					<p
						className="p-body"
						key={paragraph.slice(0, 24)}
						style={{ marginTop: index === 0 ? "32px" : "20px" }}
					>
						{paragraph}
					</p>
				))}
			</div>
		</div>
	</Reveal>
);

export default Position;
